import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
// templates list
import { InspectionModelListPageComponent } from '../pages/list.component';
import { InspectionModelListComponent } from '../components/list.component';
// detail
import { InspectionModelDetailPageComponent } from '../pages/detail.component';
import { InspectionModelStatusPageComponent } from '../pages/status.component';

// new
import { InspectionModelNewPageComponent } from '../pages/new.component';
import { InspectionModelNewComponent } from '../components/new.component';

import { InspectionModelEditPageComponent } from '../pages/edit.component';
import { InspectionModelImportModelSectionsPageComponent } from '../pages/model-sections.component';

import { routedComponents, InspectionModelRoutingModule } from './inspection-model.routing';

import { SharedModule } from '../../shared.module';
// menus
import { InspectionModelMenuComponent } from '../menus/inspection-model.menu';
import { PluginModule } from '../../plugins/modules/plugin.module';
import { InspectionModelDetailComponent } from '../../shared/components/inspections/inspection-model-detail.component';
import { InspectionModelChildrenListPageComponent } from '../pages/children-list.component';
import { InspectionModelTemplatesModalComponent } from '../components/templates-modal.component';
import { BaseImportModelSectionsPageComponent } from '../../shared/pages/importsections/model-sections.component';

@NgModule({
  imports: [CommonModule, PluginModule, SharedModule, InspectionModelRoutingModule, FormsModule, ReactiveFormsModule],
  declarations: [
    routedComponents,
    InspectionModelListPageComponent,
    InspectionModelListComponent,
    InspectionModelDetailPageComponent,
    InspectionModelNewPageComponent,
    InspectionModelNewComponent,
    InspectionModelStatusPageComponent,
    InspectionModelMenuComponent,
    InspectionModelEditPageComponent,
    InspectionModelImportModelSectionsPageComponent,
    InspectionModelDetailComponent,
    InspectionModelChildrenListPageComponent,
    InspectionModelTemplatesModalComponent,
    BaseImportModelSectionsPageComponent
  ]
})
export class InspectionModelModule {}
